import { render, staticRenderFns } from "./EditorContent.vue?vue&type=template&id=56d22e86&"
import script from "./EditorContent.vue?vue&type=script&lang=js&"
export * from "./EditorContent.vue?vue&type=script&lang=js&"
import style0 from "./EditorContent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports